var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMessageCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-48 -671) translate(48 279) translate(0 392)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30d14d",
    d: "M16.98 5.149L6.045 16.269l-4.018-4.086c-.194-.199-.51-.199-.705 0L.146 13.378c-.195.198-.195.52 0 .718l5.546 5.64c.195.198.511.198.706 0L18.86 7.062c.195-.198.195-.52 0-.718L17.685 5.15c-.195-.199-.51-.199-.705 0z",
    transform: "translate(-48 -671) translate(48 279) translate(0 392)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMessageCheckGreen);
export default __webpack_public_path__ + "static/media/icon-message-check-green.8afe3d69.svg";
export { ForwardRef as ReactComponent };